export default "__VITE_ASSET__ZClBuNED__"